import React from "react";
import { CheckoutSection } from "../CheckoutSection";
import { PlanSelection } from "../PlanSelection";

export const SubscriptionPlansTab = ({
  currentView,
  hasPlanId,
  PLANS,
  billingTabs,
  selectedPlan,
  setSelectedPlan,
  handleContinueToCheckout,
  isContinuingToCheckout,
  selectedPlanDetails,
  userPlanId,
  gstAmount,
  totalAmount,
  showZeroMarkup,
  billing,
  isProcessingPayment,
  handleInitiatePayment,
  handleSaveBillingDetails,
  setCurrentView,
  subscriptionStartDate,
  subscriptionEndDate,
}) => {
  return (
    <div className="w-full">
      {currentView === "plans" && (
        <PlanSelection
          plans={PLANS}
          billingTabs={billingTabs}
          selectedPlan={selectedPlan}
          onSelectPlan={setSelectedPlan}
          onContinue={handleContinueToCheckout}
          gstRate={selectedPlanDetails?.gstRate ?? 0.18}
          disabled={isContinuingToCheckout || hasPlanId}
          hasActivePlan={hasPlanId}
          activePlanId={userPlanId}
        />
      )}

      {currentView === "checkout" && (
        <CheckoutSection
          selectedPlanDetails={selectedPlanDetails}
          selectedPlan={selectedPlan}
          gstAmount={gstAmount}
          totalAmount={totalAmount}
          showZeroMarkup={showZeroMarkup}
          isProcessing={billing.loading}
          isLoadingSubscription={billing.loadingSubscription}
          isLoadingBillingDetails={billing.loadingBillingDetails}
          isSavingBillingDetails={billing.savingBillingDetails}
          isProcessingPayment={isProcessingPayment}
          subscription={billing.subscription}
          billingDetails={billing.billingDetails}
          onBack={() => setCurrentView("plans")}
          onPay={handleInitiatePayment}
          onSaveBillingDetails={handleSaveBillingDetails}
          onChangePlan={() => setCurrentView("plans")}
          allPlans={PLANS}
          gstRate={selectedPlanDetails?.gstRate ?? 0.18}
          subscriptionStartDate={subscriptionStartDate}
          subscriptionEndDate={subscriptionEndDate}
        />
      )}
    </div>
  );
};
